module.exports = __webpack_public_path__ + "img/KatzenMama.4cdb309b.jpg";